<template>
  <app-layout
    v-bind="$page.props"
    title="Email">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        メール配信
      </h2>
    </template>
    <div class="px-4 py-4 flex flex-col items-center">
      <div class="mt-10 sm:mt-0 min-w-full">
        <form
          action="#"
          method="POST">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-3">
                  <label
                    class="block text-sm font-medium text-gray-700">
                    送信元
                  </label>
                  <label
                    class="block text-sm font-medium text-gray-700">
                    vt-info@qnote.co.jp
                  </label>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label
                    class="block text-sm font-medium text-gray-700">
                    送信先
                  </label>
                  <select
                    v-model="form.dest_type"
                    :class="{ 'bg-red-100': !!form.errors.dest_type }"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    @change="onChangeTemplate();onChangeEmailTarget()">
                    <option
                      v-for="(n, i) in destTypes"
                      :key="i"
                      :value="i">
                      {{ n }}
                    </option>
                  </select>
                  <input-error
                    :message="form.errors.dest_type"
                    class="mt-2" />

                  <div v-if="form.dest_type === 3 && form.dest_type !== null">
                    <label
                      class="block text-sm font-medium text-gray-700">
                      対象のメールアドレス
                    </label>
                    <input
                      id="email"
                      v-model="form.email"
                      type="email"
                      :class="{ 'bg-red-100': !!form.errors.email }"
                      class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      placeholder="送信先メールアドレスを入力してください。" />
                    <input-error
                      :message="form.errors.email"
                      class="mt-2" />
                  </div>

                  <div
                    v-if="
                      form.dest_type !== 0 &&
                        form.dest_type !== 3 &&
                        form.dest_type !== null
                    ">
                    <label
                      class="block text-sm font-medium text-gray-700">
                      対象の模試
                    </label>
                    <select
                      v-model="form.examinations"
                      :class="{ 'bg-red-100': !!form.errors.examinations }"
                      class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                      <option
                        v-if="form.dest_type === 1"
                        value="0">
                        すべて
                      </option>
                      <option
                        v-for="(n, i) in examinations"
                        :key="i"
                        :value="i + 1">
                        {{ n.title }}
                      </option>
                    </select>
                    <input-error
                      :message="form.errors.examinations"
                      class="mt-2" />
                  </div>
                </div>

                <div class="col-span-6">
                  <label
                    for="subject"
                    class="block text-sm font-medium text-gray-700">
                    件名
                  </label>
                  <div class="col-span-8">
                    <input
                      id="subject"
                      v-model="form.subject"
                      type="text"
                      :class="{ 'bg-red-100': !!form.errors.subject }"
                      class="w-full rounded border-gray-400" />
                    <input-error
                      :message="form.errors.subject"
                      class="mt-2" />
                  </div>
                </div>

                <div class="col-span-6">
                  <label
                    for="contents"
                    class="block text-sm font-medium text-gray-700">
                    本文
                  </label>
                  <textarea
                    id="contents"
                    v-model="form.contents"
                    class="resize w-full rounded border-gray-400 whitespace-pre-wrap"
                    :class="{ 'bg-red-100': !!form.errors.contents }"
                    cols="40"
                    rows="10">
                  </textarea>
                  <input-error
                    :message="form.errors.contents"
                    class="mt-2" />
                </div>
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 flex justify-between sm:px-6">
              <div>
                <button
                  v-if="!form.wasSuccessful"
                  class="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click.prevent="onSubmitted">
                  確認する
                </button>
              </div>
            </div>
          </div>
        </form>
        <p
          class="text-lg mt-10 mb-2 font-medium text-gray-700">
          メール送信履歴
        </p>
        <div class="mx-auto max-w-full shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="table-fixed w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="w-2/12 px-3 py-3 text-left text-xs font-medium text-gray-500">
                  送信日時
                </th>
                <th
                  class="w-3/12 px-3 py-3 text-left text-xs font-medium text-gray-500">
                  送信先
                </th>
                <th
                  class="w-3/12 px-3 py-3 text-left text-xs font-medium text-gray-500">
                  件名
                </th>
                <th
                  class="w-4/12 px-3 py-3 text-left text-xs font-medium text-gray-500 ">
                  本文
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(emailLog, i) in emailLogs"
              :key="i"
              class="bg-white divide-y divide-gray-200">
              <tr>
                <td class="px-3 py-4 max-w-0 text-ellipsis truncate overflow-hidden text-sm text-gray-900">
                  {{ formatCreatedAt(emailLog) }}
                </td>
                <td class="px-3 py-4 max-w-0 text-ellipsis truncate overflow-hidden text-sm text-gray-900">
                  {{ emailLog.logText }}
                </td>
                <td class="px-3 py-4 max-w-0 text-ellipsis truncate overflow-hidden text-sm text-gray-900">
                  {{ emailLog.subject }}
                </td>
                <td class="px-3 py-4 max-w-0 text-ellipsis truncate overflow-hidden text-sm text-gray-900">
                  {{ emailLog.contents }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import {
  reactive, computed,
} from 'vue'
import InputError from '@/Jetstream/InputError'
import AppLayout from '@/Layouts/AppLayout'

const props = defineProps({
  examinations: {
    type: Array,
    default: () => [],
  },
  requestDestType: {
    type: Number,
    default: null,
  },
  requestExaminations: {
    type: Number,
    default: 1,
  },
  requestSubject: {
    type: String,
    default: '',
  },
  requestContents: {
    type: String,
    default: '',
  },
  requestEmail: {
    type: String,
    default: '',
  },
  emailLogs: {
    type: Array,
    default: () => [],
  },

})
const destTypes = computed(() => usePage().props.value.destTypes)

// クエリパラメータがあったときの初期値を処理分け(show.vueで戻るボタン押下時)
const destType = props.requestDestType !== undefined ? props.requestDestType : null
const examination = props.requestExaminations !== null ? props.requestExaminations : 1
const subject = props.requestSubject !== undefined ? props.requestSubject : null
const contents = props.requestContents !== undefined ? props.requestContents : null
const email = props.requestEmail !== undefined ? props.requestEmail : null

const formatCreatedAt = (information) => {
  const date = moment(information.created_at)
  const formatDate = date.format('yyyy/MM/DD kk:mm')
  return formatDate
}

const form = reactive(Inertia.form({
  id: null,
  _method: 'POST',
  dest_type: destType,
  examinations: examination,
  subject,
  contents,
  email,
}))

const onChangeTemplate = () => {
  if (form.dest_type === 0 && form.contents === null) {
    form.subject = '登録者件名テンプレート'
    form.contents = '登録者本文テンプレート\nここは後で変更します。\n販売先は<a href="https://www.google.com/">こちら</a>\nお問い合わせは<a href="https://www.google.com/">お問い合わせ</a>'
  } else if (form.dest_type === 1 && form.contents === null) {
    form.subject = '対象の模試購入者件名テンプレート'
    form.contents = '対象の模試購入者本文テンプレート\nここは後で変更します。\n販売先は<a href="https://www.google.com/">こちら</a>\nお問い合わせは<a href="https://www.qnote.co.jp/">お問い合わせ</a>'
  } else if (form.dest_type === 2 && form.contents === null) {
    form.subject = '対象の模試未購入者件名テンプレート'
    form.contents = '対象の模試未購入者本文テンプレート\nここは後で変更します。'
  }
}

const onChangeEmailTarget = () => {
  if (form.dest_type !== 3) {
    form.email = null
  }
}

const onSubmitted = async () => {
  await form.post(route('mail.show'), {
    dest_type: form.dest_type,
    examinations: form.examinations,
    subject: form.subject,
    contents: form.contents,
    email: form.email,
  })
}
</script>
